<script setup lang="ts">
import { PhSquaresFour as SquaresFour, PhSparkle as Sparkle } from "@phosphor-icons/vue";

defineProps<{
  compact?: boolean;
  label?: string;
}>();
</script>

<template>
  <div class="brand-bar" :class="{ 'brand-bar--compact': compact }">
    <span class="brand-mark"><SquaresFour weight="fill" :size="17" /> NBTI</span>
    <span class="brand-label"><Sparkle weight="fill" :size="13" /> {{ label || "牛马体质鉴定所" }}</span>
  </div>
</template>
